export const defaultTemplateId = 'main'
